import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    announcement: null,
    announcements: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const announcementsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.ANNOUNCEMENT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.ANNOUNCEMENT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.ANNOUNCEMENT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default announcementsReducer;
